import React from 'react';
import { Link } from 'react-router-dom';
import Grid from '../../../../Component/grid/Grid';
import ModalDialog from '../../../../Component/modaldialog/ModalDialog';
import AlertMessage from '../../../../Component/alert/AlertMessage';
import BaseScreen from '../../BaseScreen';
import { SCREENS } from '../../../../constants/screens.constant';
import { ImplementsService } from '../../../../services/service.implements';
import AppInfoHelper from '../../../../shared/utils/appInfoHelper';
import { ROLE_TYPES } from '../../../../constants/app.constants';
import i18n from 'i18next';

/**
 * Informations to be shown in implement listing grid, along with options per rows.
 */
let implementListConfig = {};

/**
 * List Implements component
 */
class ListImplements extends BaseScreen {
  constructor (props) {
    super(props);
    let isAuthenticated = true;
    if (!this.isAuth()) {
      isAuthenticated = false;
      this.goToScreen(SCREENS.login);
    }

    // initialize implementListConfig with updated i18n resources
    implementListConfig = {
      name: {
        label: i18n.t('userVehicles.implements.list.name'),
        sort: false,
        filter: true,
        display: true,
        filterMaxLength: 50
      },
      length: {
        label: i18n.t('userVehicles.implements.list.length'),
        sort: false,
        filter: false,
        display: true,
        filterMaxLength: 50
      },
      options: {
        label: i18n.t('userVehicles.implements.list.options.options'),
        sort: false,
        filter: false,
        display: true,
        list: [
          {
            actionType: 'link',
            action: 'view',
            label: i18n.t('userVehicles.implements.list.options.view')
          }, {
            actionType: 'link',
            action: 'edit',
            label: i18n.t('userVehicles.implements.list.options.edit')
          }, {
            actionType: '',
            action: 'delete',
            label: i18n.t('userVehicles.implements.list.options.delete')
          }
        ]
      }
    };

    this.state = {
      isAuthenticated: isAuthenticated,
      loggedInUserInfo: undefined,
      selectedAccountHolder: undefined,
      selectedVehicleTypes: 'assigned',
      implementsData: [],
      loader: true,
      pgnConfig: {
        currentPage: 1,
        numberOfPageLinks: 0,
        countPerPage: 25,
        totalCount: 0,
        pageList: [25, 50, 100]
      },
      modal: {
        modalShow: false,
        shouldRenderModal: false,
        modalTitle: '',
        modalMsg: '',
        modalData: '',
        modalAction: ''
      },
      alert: {
        type: null,
        message: null
      },
      sortFieldsConfig: {},
      filterFieldsConfig: {},
      reinitialize: false,
      defaultSortField: 'modifiedAt',
      defaultSortOrder: -1
    };
  }

  /**
   * on mount resolve user role and fetch list of implements from implement backend service
   */
  componentDidMount () {
    const self = this;
    // check userRole first
    const userInfoInstance = AppInfoHelper.getUserInstance();
    userInfoInstance.getUserInfo().then(function (response) {
      const userInfo = response;
      const selectedAccountHolder = userInfoInstance.getSelectedAccountHolderForOperator();
      if (userInfo.roleId === ROLE_TYPES.OPERATOR.ID && !selectedAccountHolder) {
        const warningMsg = i18n.t('userVehicles.implements.alert.selectAccountholder');
        self.setState(
          {
            implementsData: [],
            loader: false,
            loggedInUserInfo: response,
            modalShow: false,
            reinitialize: false,
            alert: {
              type: 'danger',
              message: warningMsg
            }
          });
      } else {
        self.setState(
          {
            loader: true,
            loggedInUserInfo: response,
            selectedAccountHolder: selectedAccountHolder
          });
        const accountHolderId = response.roleId === ROLE_TYPES.ACCOUNT_HOLDER.ID
          ? userInfo.id : selectedAccountHolder.id;
        const arg = {
          currentPage: 0,
          pageSize: self.state.pgnConfig.countPerPage,
          accountHolderId: accountHolderId
        };
        self.getImplementsData(arg, self.state.sortFieldsConfig, self.state.filterFieldsConfig, accountHolderId)
          .then(response => {
            const pgnConfig = self.setPaginationConfig(self.state.pgnConfig.currentPage, self.state.pgnConfig.countPerPage, response.data.total);
            self.setState({ implementsData: response.data.items, loader: false, pgnConfig: pgnConfig, modalShow: false, reinitialize: false });
          }, error => {
            let errorMsg = i18n.t('common.genericApiError');
            if (error && error.data && error.data.message) {
              errorMsg = error.data.message;
            }
            self.setState(
              {
                implementsData: [],
                loader: false,
                modalShow: false,
                reinitialize: false,
                alert: {
                  type: 'danger',
                  message: errorMsg
                }
              });
          });
      }
    }, function (error) {});
  }

  /**
   * fetch data from backend to display on ui.
   * @param {*} requiredParams 
   * @param {*} sortFieldsObj 
   * @param {*} filterFieldsObj 
   * @param {*} accountHolderId 
   */
  getImplementsData (requiredParams, sortFieldsObj, filterFieldsObj, accountHolderId) {
    let accountHolder = '';
    if (accountHolderId && accountHolderId !== '') {
      accountHolder = accountHolderId;
    } else if (this.state.loggedInUserInfo && this.state.loggedInUserInfo.roleId === ROLE_TYPES.ACCOUNT_HOLDER.ID) {
      accountHolder = this.state.loggedInUserInfo.id;
    } else if (this.state.selectedAccountHolder && this.state.selectedAccountHolder.id) {
      accountHolder = this.state.selectedAccountHolder.id;
    }
    let reqQueryParams = '';
    let params;
    if (requiredParams) {
      params = {
        currentPage: requiredParams.currentPage,
        pageSize: requiredParams.pageSize
      };
    } else {
      params = {
        currentPage: this.state.pgnConfig.currentPage - 1,
        pageSize: this.state.pgnConfig.countPerPage
      };
    }
    reqQueryParams = 'currentPage=' + params.currentPage + '&pageSize=' + params.pageSize;
    let sortFiledsQueryParams = '';
    if (!sortFieldsObj) {
      sortFieldsObj = this.state.sortFieldsConfig;
    }
    let sortQueryTemp = '';
    let key;
    for (key in sortFieldsObj) {
      const sortValue = sortFieldsObj[key].sortOrder;
      if (sortValue) {
        sortQueryTemp = 'sortfield=' + key + '&orderType=' + ((sortValue === 1) ? 'asc' : 'desc');
        sortFiledsQueryParams += '&' + sortQueryTemp;
      }
    }
    let filterFielddQueryParams = '';
    if (!filterFieldsObj) {
      filterFieldsObj = this.state.filterFieldsConfig;
    }

    let filterQueryTemp = '';
    for (key in filterFieldsObj) {
      const filterValue = filterFieldsObj[key].value;
      if (filterValue) {
        filterQueryTemp = key + '=' + filterValue;
        filterFielddQueryParams += '&' + filterQueryTemp;
      }
    }

    reqQueryParams += sortFiledsQueryParams + filterFielddQueryParams;

    if (accountHolder) {
      reqQueryParams += '&accountId=' + accountHolder;
    }

    return ImplementsService.getImplements(reqQueryParams)
      .then(response => {
        return response;
      }, errResponse => {
        return Promise.reject(errResponse);
      });
  }

  /**
   * helper function for pagination configuration
   * @param {*} currentPage 
   * @param {*} countPerPage 
   * @param {*} totalCount 
   */
  setPaginationConfig (currentPage, countPerPage, totalCount) {
    return {
      currentPage: currentPage,
      numberOfPageLinks: this.state.pgnConfig.numberOfPageLinks,
      countPerPage: countPerPage,
      totalCount: totalCount,
      pageList: [...this.state.pgnConfig.pageList]
    };
  }

  /**
   * handler when page number change, like user move to next page or previous page from current page he is viewing
   */
  onPgnChange (pageNumber) {
    if (pageNumber !== this.state.pgnConfig.currentPage) {
      window.scrollTo(0, 0);
      this.setState({ loader: true, implementsData: [] });

      const arg = {
        currentPage: (pageNumber - 1),
        pageSize: this.state.pgnConfig.countPerPage
      };

      this.getImplementsData(arg).then((response) => {
        const pgnConfig = this.setPaginationConfig(pageNumber, this.state.pgnConfig.countPerPage, response.data.total);
        this.setState({
          implementsData: response.data.items,
          loader: false,
          pgnConfig: pgnConfig,
          alert: {
            type: null,
            message: null
          },
          modalShow: false
        });
      }, (error) => {
        let errorMsg = i18n.t('common.genericApiError');
        if (error && error.data && error.data.message) {
          errorMsg = error.data.message;
        }
        this.setState(
          {
            implementsData: [],
            loader: false,
            modalShow: false,
            alert: {
              type: 'danger',
              message: errorMsg
            }
          });
      });
    }
  }

  /**
   * handles the grid listing when there is any change per page row count, like if user chose default row count 25 to 50 or something else.
   * @param {*} event 
   */
  onPgnRowsCountChange (event) {
    window.scrollTo(0, 0);
    const perPageItems = Number(event.target.value);
    let currentPage;
    if ((this.state.pgnConfig.currentPage - 1) * perPageItems >= this.state.pgnConfig.totalCount) {
      currentPage = 1;
    } else {
      currentPage = this.state.pgnConfig.currentPage;
    }
    this.setState({ loader: true, implementsData: [] });
    const arg = {
      currentPage: currentPage - 1,
      pageSize: perPageItems
    };
    this.getImplementsData(arg).then((response) => {
      const pgnConfig = this.setPaginationConfig(currentPage, perPageItems, response.data.total);
      this.setState({
        implementsData: response.data.items,
        loader: false,
        pgnConfig: pgnConfig,
        alert: {
          type: null,
          message: null
        },
        modalShow: false
      });
    }, (error) => {
      let errorMsg = i18n.t('common.genericApiError');
      if (error && error.data && error.data.message) {
        errorMsg = error.data.message;
      }
      this.setState(
        {
          implementsData: [],
          loader: false,
          modalShow: false,
          alert: {
            type: 'danger',
            message: errorMsg
          }
        });
    });
  }

  /**
   * lazy load function when user use filter or sort functionality from grid header
   * @param {*} sortFieldsObj 
   * @param {*} filterFieldsObj 
   */
  onLazyLoad (sortFieldsObj, filterFieldsObj) {
    this.setState({ loader: true, implementsData: [] });

    const pageNumber = 1;
    const arg = {
      currentPage: pageNumber - 1,
      pageSize: this.state.pgnConfig.countPerPage
    };

    this.getImplementsData(arg, sortFieldsObj, filterFieldsObj)
      .then((response) => {
        const pgnConfig = this.setPaginationConfig(pageNumber, this.state.pgnConfig.countPerPage, response.data.total);

        // sortingData
        if (!sortFieldsObj) {
          sortFieldsObj = this.state.sortFieldsConfig;
        }

        // filteringData
        if (!filterFieldsObj) {
          filterFieldsObj = this.state.filterFieldsConfig;
        }

        this.setState({
          implementsData: response.data.items,
          loader: false,
          pgnConfig: pgnConfig,
          alert: {
            type: null,
            message: null
          },
          modalShow: false,
          sortFieldsConfig: sortFieldsObj,
          filterFieldsConfig: filterFieldsObj
        });
      }, (error) => {
        let errorMsg = i18n.t('common.genericApiError');
        if (error && error.data && error.data.message) {
          errorMsg = error.data.message;
        }
        this.setState(
          {
            implementsData: [],
            loader: false,
            modalShow: false,
            alert: {
              type: 'danger',
              message: errorMsg
            }
          });
      });
  }

  /**
   * routing to relevant page based on row option selection
   * @param {*} actionType 
   * @param {*} row 
   */
  actionPaths (actionType, row) {
    if (actionType.action === 'view') {
      return ({
        pathname: '/user-vehicles/implements/view-implement/' + row.id,
        state: { implementData: [] }
      });
    } else if (actionType.action === 'edit') {
      return ({
        pathname: '/user-vehicles/implements/edit-implement/' + row.id,
        state: { implementData: [], loggedInUserInfo: this.state.loggedInUserInfo }
      });
    }
  }

  /**
   * for handling options having confirmation modals
   * @param {*} actionObject 
   * @param {*} row 
   */
  optionHandler (actionObject, row) {
    let modalInfo;
    if (actionObject.action === 'delete') {
      modalInfo = {
        modalMsg: i18n.t('userVehicles.implements.form.modal.deleteMsg', { name: row.name }),
        modalTitle: i18n.t('userVehicles.implements.form.modal.deleteTitle'),
        modalAction: 'delete_implement'
      };
    }
    this.modalPopup(true, row, modalInfo);
  }

  /**
   * Modal window to show each row options
   * @param {*} state 
   * @param {*} rowData 
   * @param {*} modalInfo 
   */
  modalPopup (state, rowData, modalInfo) {
    if (state) {
      this.setState({
        modal: {
          modalShow: state,
          shouldRenderModal: true,
          modalMsg: modalInfo.modalMsg,
          modalTitle: modalInfo.modalTitle,
          modalData: rowData || '',
          modalAction: modalInfo.modalAction
        }
      });
    } else {
      this.setState({
        modal: {
          modalShow: state,
          shouldRenderModal: true,
          modalData: rowData || '',
          modalAction: this.state.modal.modalAction
        }
      });
    }
  }

  /**
   * modal dismissal action
   */
  handleModalDismiss () {
    this.modalPopup(false);
  }

  /**
   *  handle modal delete action.
   * @param {*} data 
   */
  onModalAction (data) {
    const modalAction = this.state.modal.modalAction;
    if (modalAction === 'delete_implement') {
      this.modalPopup(false, data);
    }
  }

  /**
   * function after modal is closed, re-render listing page after delete operation.
   */
  onModalClosed () {
    if (this.state.modal.modalAction === 'delete_implement') {
      this.deleteImplement();
    }
  }

  /**
   * deletes an implement from backend
   */
  deleteImplement () {
    if (this.state.modal.modalData) {
      const modalData = this.state.modal.modalData;
      this.setState({
        loader: true,
        modal: {
          modalShow: false,
          shouldRenderModal: false
        }
      });
      ImplementsService.deleteImplement(modalData.id)
        .then((successResponse) => {
          let pageNumber = this.state.pgnConfig.currentPage;
          if ((this.state.implementsData.length <= 1) && (this.state.pgnConfig.currentPage > 1)) {
            pageNumber = this.state.pgnConfig.currentPage - 1;
          }
          this.setState({
            implementsData: [],
            alert: {
              type: 'success',
              message: i18n.t('userVehicles.implements.alert.implementDelete')
            }
          });
          const arg = {
            currentPage: (pageNumber - 1),
            pageSize: this.state.pgnConfig.countPerPage
          };
          this.getImplementsData(arg).then((response) => {
            const pgnConfig = this.setPaginationConfig(pageNumber, this.state.pgnConfig.countPerPage, response.data.total);
            this.setState({
              implementsData: response.data.items,
              loader: false,
              pgnConfig: pgnConfig,
              modal: {
                modalShow: false,
                shouldRenderModal: false
              }
            });
          }, (error) => {
            let errorMsg = i18n.t('common.genericApiError');
            if (error && error.data && error.data.message) {
              errorMsg = error.data.message;
            }
            this.setState(
              {
                implementsData: [],
                loader: false,
                alert: {
                  type: 'danger',
                  message: errorMsg
                }
              });
          });
        }, (error) => {
          let errorMsg = i18n.t('common.genericApiError');
          if (error && error.data && error.data.message) {
            errorMsg = error.data.message;
          }
          this.setState(
            {
              loader: false,
              alert: {
                type: 'danger',
                message: errorMsg
              }
            });
        });
    }
  }

  /*
   alert message handling
   */
  handleAlertDismiss () {
    this.setState({
      alert: {
        type: null,
        message: null
      }
    });
  }

  /**
   * react render to render implement list
   */
  render () {
    let isSelectedAccountHolder = false;
    let accountHolder = '';
    if (this.state.selectedAccountHolder) {
      isSelectedAccountHolder = true;
      accountHolder = this.state.selectedAccountHolder;
    } else if (this.state.loggedInUserInfo && this.state.loggedInUserInfo.roleId === ROLE_TYPES.ACCOUNT_HOLDER.ID) {
      isSelectedAccountHolder = true;
      accountHolder = this.state.loggedInUserInfo;
    }

    return (
      <div>
        <div className="container-fluid p-4">
          <div className="clearfix"></div>
          {
            this.state.alert.message &&
            <AlertMessage message={this.state.alert.message}
              type={this.state.alert.type}
              isAlertOpen={!!(this.state.alert.message)}
              handleDismiss={this.handleAlertDismiss.bind(this)}
            />
          }
          <div className="row">
            <div className="col-md-12 text-right f-btn">
              {
                (
                  isSelectedAccountHolder
                    ? <Link className="btn btn-primary" to={
                      {
                        pathname: '/user-vehicles/implements/create-implement',
                        params: { accountHolder: [accountHolder] }
                      }} data-testid="create-implement-link">
                      {i18n.t('userVehicles.implements.form.button.createImplement')}
                    </Link>
                    : <button className={'btn mr-2 btn-primary'} disabled>
                      {i18n.t('userVehicles.implements.form.button.createImplement')}
                    </button>
                )
              }
            </div>
          </div>
          <div className="clearfix"></div>
          <div>
            <Grid id="implementsListGrid"
              optionHandler={this.optionHandler.bind(this)}
              keyColumn="id"
              rowData={this.state.implementsData}
              reinitialize={this.state.reinitialize}
              columnDefs={implementListConfig}
              loading={this.state.loader}
              pagination={true}
              pgnConfig={this.state.pgnConfig}
              onPgnChange={this.onPgnChange.bind(this)}
              onPgnRowsCountChange={this.onPgnRowsCountChange.bind(this)}
              pageList={this.state.pageList}
              lazyLoading={true}
              onLazyLoad={this.onLazyLoad.bind(this)}
              actionPaths={this.actionPaths.bind(this)}
              defaultSortField={this.state.defaultSortField}
              defaultSortOrder={this.state.defaultSortOrder} />
          </div>
        </div>
        {
          this.state.modal.shouldRenderModal &&
          <ModalDialog modalTitle={this.state.modal.modalTitle}
            modalMessage={this.state.modal.modalMsg}
            modalData={this.state.modal.modalData}
            isModalOpen={this.state.modal.modalShow}
            modalAction={this.onModalAction.bind(this)}
            handleModalDismiss={this.handleModalDismiss.bind(this)}
            onModalClosed={this.onModalClosed.bind(this)}
          />
        }
      </div>);
  }
}

export default ListImplements;
